import "./ConfigurePanelDialog.css";
import Tooltip from "@mui/material/Tooltip";

export function Category({ item, onClick, isSubCategory = false }) {
  const handleClickCategory = () => {
    onClick(!item.isSelected, item.id);
  };

  return (
    <Tooltip
      className="custom-tooltip"
      title={item.name}
      placement="bottom"
      arrow
    >
      <div className="category-container-item">
        <button
          className={`configure-panel-dialog-category-btn${
            item.isSelected ? " selected" : ""
          }`}
          onClick={handleClickCategory}
        >
          <span className={item?.iconPath + " icon-category"} />
          <div>
            <span className="icon-check-2"></span>
          </div>
        </button>
        {isSubCategory && <span className="title">{item.name}</span>}
      </div>
    </Tooltip>
  );
}
